import qs from 'qs';

import { ROUTE as GET_ROUTE, Params as GetParams, Result as GetResult } from 'api/mandate/website/get/params';
import {
  ROUTE as GET_ALL_ROUTE,
  Params as GetAllParams,
  Result as GetAllResult,
} from 'api/mandate/website/get-all/params';
import { ApiResponse } from 'src/types/api-response';

import api from '..';

export const mandate = api.injectEndpoints({
  endpoints: (builder) => ({
    getMandate: builder.query<ApiResponse<GetResult>, GetParams>({
      query: (params) => ({
        method: 'GET',
        url: GET_ROUTE.replace(':id', params.id),
      }),
      providesTags: (result, err, params) =>
        result?.success
          ? [
              { type: 'MANDATE', id: params.id },
              { type: 'MANDATE', id: 'ALL' },
            ]
          : [{ type: 'MANDATE', id: 'ALL' }],
    }),
    getMandates: builder.query<ApiResponse<GetAllResult>, GetAllParams>({
      query: (params) => ({
        method: 'GET',
        url: `${GET_ALL_ROUTE}?${qs.stringify(params)}`,
      }),
    }),
  }),
  overrideExisting: false,
});
